import React, { useMemo, useState } from 'react';
import { useControl } from '../../components/ControlLayout';
import { Loading } from '../../../../components/Loading';
import { Error } from '../../../../components/Error';
import { CompaniesTable } from './components/CompaniesTable';
import { Images } from '@ansvar-sakerhet/ui/src/assets/images';
import { useNavigate, useParams } from 'react-router-dom';
import { S } from './CompaniesData.style';
import { useCompanies } from '../../components/ControlLayout/ControlLayout';
import { SearchInput } from '../../../../components/SearchInput';
import {
  CompaniesTableSortDropdown,
  SortCompanies,
} from './components/CompaniesTableSort/CompaniesTableSortDropdown';

export const CompaniesData: React.FC = () => {
  const navigate = useNavigate();
  const control = useControl();
  const companies = useCompanies();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState<SortCompanies>('none');

  const visibleCompanies = useMemo(() => {
    const filtered = (companies.data ?? []).filter((company) =>
      company.name.toLowerCase().includes(search.trim().toLowerCase())
    );

    const direction = sort.endsWith('DESC') ? -1 : 1;
    if (sort === 'name_ASC' || sort === 'name_DESC') {
      return [...filtered].sort(
        (a, b) => direction * a.name.localeCompare(b.name)
      );
    }
    if (sort === 'registrationNumber_ASC' || sort === 'registrationNumber_DESC') {
      return [...filtered].sort(
        (a, b) =>
          direction * a.registrationNumber.localeCompare(b.registrationNumber)
      );
    }
    return filtered;
  }, [companies.data, search, sort]);

  const { state } = useParams();

  const navigateToCoverPage = () => {
    window.scrollTo(0, 0);
    navigate(`/kontroller/${state}/${control.data.inspectionId}/forsattsblad`);
  };

  if (companies.isLoading) {
    return <Loading />;
  }

  return (
    <S.Container>
      {companies.data && companies.data?.length > 0 ? (
        <S.TableContainer>
          {companies.isLoading && <Loading />}

          {companies.isError && <Error refetch={companies.refetch} />}

          {companies.isSuccess && (
            <React.Fragment>
              <S.Margin $spacing="xs" />

              <S.Header>
                <S.B3 $color="darkGray">{visibleCompanies.length} st</S.B3>

                <S.HeaderActions>
                  <SearchInput
                    input={search}
                    setInput={setSearch}
                    placeholder="Sök efter namn"
                  />
                  <CompaniesTableSortDropdown sort={sort} setSort={setSort} />
                </S.HeaderActions>
              </S.Header>

              <CompaniesTable
                data={visibleCompanies}
                loading={companies.isLoading}
                page={page}
                setPage={setPage}
              />
            </React.Fragment>
          )}
        </S.TableContainer>
      ) : (
        <S.EmptyContainer>
          <img
            src={Images.Empty}
            width={279}
            height={204}
            alt="no content available"
          />

          <S.TextContainer>
            <S.H5>Här var det tomt!</S.H5>

            <S.B2>
              Det kan bero på att datan har raderats i ett tidigare skede
            </S.B2>
          </S.TextContainer>
        </S.EmptyContainer>
      )}

      <S.Footer>
        <S.Button $width={289} onClick={navigateToCoverPage}>
          Nästa
        </S.Button>
      </S.Footer>
    </S.Container>
  );
};
